import React, { useEffect, useRef } from 'react';
import { closeModal } from '../../store/features/modalSlice';
import { useAppDispatch } from '../../store/hook';
import HFbutton from '../button/HFbutton';
import { downloadDiv } from '../../api/utils/util-func';
import dayjs from 'dayjs';
import {
  ConfettiFirework,
  ConfettiFireworkRef,
} from '../confetti/ConfettiFirework';

interface ModalRecitationCertificateProps {
  englishName: string;
  subject: string;
  date: Date;
}
const ModalRecitationCertificate = ({
  englishName,
  subject,
  date,
}: ModalRecitationCertificateProps) => {
  const dispatch = useAppDispatch();
  const confettiRef = useRef<ConfettiFireworkRef>(null);
  const downloadHandler = () => {
    downloadDiv('certificate', `${englishName} ${subject}`);
  };
  const closeHandler = () => {
    dispatch(closeModal());
  };

  const triggerConfetti = () => {
    confettiRef.current?.startFire();
  };

  useEffect(() => {
    triggerConfetti();
  }, []);
  return (
    <div className="relative mt-[140px] flex w-full max-w-[240px] flex-col gap-2 rounded-lg bg-white p-5 xl:mt-0">
      <div className="relative" id="certificate" onClick={triggerConfetti}>
        <div className="absolute left-0 top-0 w-full">
          <span className="absolute top-[126px] w-full text-center text-[16px]">
            {englishName}
          </span>
          <span className="absolute left-[42px] top-[170px] block w-full text-center text-[8px]">
            {subject}
          </span>
          <span className="absolute left-[15px] top-[190px] block w-full text-center text-[8px]">
            {dayjs(date).format('YYYY-MM-DD')}
          </span>
        </div>
        <img
          src={process.env.PUBLIC_URL + '/images/certification/recitation.jpg'}
        />
      </div>
      <HFbutton height={36} onClick={downloadHandler}>
        다운로드
      </HFbutton>
      <HFbutton height={36} type="primary-outlined" onClick={closeHandler}>
        닫기
      </HFbutton>
      <div className="pointer-events-none fixed left-0 top-0 h-screen w-full">
        <ConfettiFirework ref={confettiRef} />
      </div>
    </div>
  );
};

export default ModalRecitationCertificate;
